import { useState } from "react";
import { ziyaretciFunnel } from "@/mocks/dashboard";

const CARD_BG = "#141720";
const BORDER = "#1e2130";
const TEXT_PRIMARY = "#e8eaf0";
const TEXT_SECONDARY = "#5a5f7a";

export default function ZiyaretciAkisi() {
  const [hoveredAdim, setHoveredAdim] = useState<number | null>(null);
  const maxSayi = ziyaretciFunnel[0].sayi;

  const kayipAdim = ziyaretciFunnel.reduce((max, adim, i) => {
    if (i === 0) return max;
    const kayip = ziyaretciFunnel[i - 1].sayi - adim.sayi;
    return kayip > max.kayip ? { index: i, kayip, adim: adim.adim, onceki: ziyaretciFunnel[i - 1].adim } : max;
  }, { index: 0, kayip: 0, adim: "", onceki: "" });

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <h2 className="text-lg font-bold" style={{ color: TEXT_PRIMARY }}>Ziyaretçi Akış Haritası</h2>
          <p className="text-sm mt-1" style={{ color: TEXT_SECONDARY }}>Ziyaretçilerin adım adım hareketleri ve kayıp noktaları</p>
        </div>
        <div className="flex items-center gap-2">
          {["Son 7 Gün", "Son 30 Gün", "Bu Ay"].map((opt) => (
            <select key={opt} className="text-sm rounded-lg px-3 py-2 cursor-pointer outline-none" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}`, color: "#8b8fa8" }}>
              <option>{opt}</option>
            </select>
          )).slice(0, 1)}
          <select className="text-sm rounded-lg px-3 py-2 cursor-pointer outline-none" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}`, color: "#8b8fa8" }}>
            <option>Tüm Kampanyalar</option>
            <option>Yaz Tatili Paketi</option>
            <option>Erken Rezervasyon</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Funnel */}
        <div className="lg:col-span-2 space-y-3">
          {ziyaretciFunnel.map((adim, i) => {
            const genislik = (adim.sayi / maxSayi) * 100;
            const oncekiSayi = i > 0 ? ziyaretciFunnel[i - 1].sayi : adim.sayi;
            const kayipYuzde = i > 0 ? (((oncekiSayi - adim.sayi) / oncekiSayi) * 100).toFixed(1) : null;
            const isHovered = hoveredAdim === i;

            return (
              <div key={i}>
                {i > 0 && kayipYuzde && (
                  <div className="flex items-center gap-2 py-1 px-4">
                    <div className="flex-1 h-px" style={{ backgroundColor: BORDER }}></div>
                    <span className="text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap" style={{ backgroundColor: "rgba(239,68,68,0.15)", color: "#ef4444" }}>
                      ↓ %{kayipYuzde} kayıp ({(oncekiSayi - adim.sayi).toLocaleString("tr-TR")} kişi)
                    </span>
                    <div className="flex-1 h-px" style={{ backgroundColor: BORDER }}></div>
                  </div>
                )}
                <div
                  className="rounded-2xl transition-all duration-200 cursor-pointer overflow-hidden"
                  style={{
                    backgroundColor: isHovered ? "#1a1d28" : CARD_BG,
                    border: `1px solid ${isHovered ? "#2a2d3a" : BORDER}`,
                  }}
                  onMouseEnter={() => setHoveredAdim(i)}
                  onMouseLeave={() => setHoveredAdim(null)}
                >
                  <div className="p-4">
                    <div className="flex items-center gap-4">
                      <div
                        className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 text-white font-bold text-sm"
                        style={{ backgroundColor: adim.renk }}
                      >
                        {i + 1}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between mb-2">
                          <p className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>{adim.adim}</p>
                          <div className="flex items-center gap-3">
                            <span className="text-xl font-bold" style={{ color: TEXT_PRIMARY }}>{adim.sayi.toLocaleString("tr-TR")}</span>
                            <span className="text-sm" style={{ color: TEXT_SECONDARY }}>%{adim.yuzde}</span>
                          </div>
                        </div>
                        <div className="h-2 rounded-full overflow-hidden" style={{ backgroundColor: "#1e2130" }}>
                          <div
                            className="h-full rounded-full transition-all duration-700"
                            style={{ width: `${genislik}%`, backgroundColor: adim.renk, opacity: 0.85 }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Sağ Panel */}
        <div className="space-y-4">
          {/* Kritik Kayıp */}
          <div
            className="rounded-2xl p-5"
            style={{ backgroundColor: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.2)" }}
          >
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ backgroundColor: "rgba(239,68,68,0.15)" }}>
                <i className="ri-alert-line text-sm" style={{ color: "#ef4444" }}></i>
              </div>
              <p className="text-sm font-bold" style={{ color: "#ef4444" }}>En Yüksek Kayıp Noktası</p>
            </div>
            <p className="text-sm mb-2" style={{ color: "#c8cad8" }}>
              <strong style={{ color: "#e8eaf0" }}>{kayipAdim.onceki}</strong> → <strong style={{ color: "#e8eaf0" }}>{kayipAdim.adim}</strong> arasında
            </p>
            <p className="text-2xl font-bold mb-1" style={{ color: "#ef4444" }}>{kayipAdim.kayip.toLocaleString("tr-TR")} kişi</p>
            <p className="text-xs mb-4" style={{ color: TEXT_SECONDARY }}>bu adımda kaybedildi</p>
            <div className="rounded-xl p-3" style={{ backgroundColor: "rgba(239,68,68,0.1)" }}>
              <p className="text-xs font-medium" style={{ color: "#ef4444" }}>Öneri</p>
              <p className="text-xs mt-1" style={{ color: "#f87171" }}>Bu adımı optimize etmeyi düşünün. İçerik sadeleştirmesi dönüşümü artırabilir.</p>
            </div>
          </div>

          {/* Özet */}
          <div className="rounded-2xl p-5" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
            <p className="text-sm font-bold mb-4" style={{ color: TEXT_PRIMARY }}>Akış Özeti</p>
            <div className="space-y-3">
              {[
                { label: "Toplam Giriş", deger: "12.847", renk: "#7c3aed" },
                { label: "Forma Ulaşan", deger: "1.423", renk: "#10b981" },
                { label: "Genel Dönüşüm", deger: "%11.1", renk: "#f59e0b" },
                { label: "Ortalama Adım", deger: "3.2", renk: "#a78bfa" },
              ].map((item, i) => (
                <div key={i} className="flex items-center justify-between">
                  <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{item.label}</p>
                  <p className="text-sm font-bold" style={{ color: item.renk }}>{item.deger}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Cihaz */}
          <div className="rounded-2xl p-5" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
            <p className="text-sm font-bold mb-4" style={{ color: TEXT_PRIMARY }}>Cihaz Dağılımı</p>
            <div className="space-y-3">
              {[
                { label: "Mobil", yuzde: 68, renk: "#7c3aed" },
                { label: "Masaüstü", yuzde: 24, renk: "#10b981" },
                { label: "Tablet", yuzde: 8, renk: "#f59e0b" },
              ].map((item, i) => (
                <div key={i}>
                  <div className="flex items-center justify-between mb-1">
                    <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{item.label}</p>
                    <p className="text-xs font-semibold" style={{ color: "#c8cad8" }}>%{item.yuzde}</p>
                  </div>
                  <div className="h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: "#1e2130" }}>
                    <div className="h-full rounded-full" style={{ width: `${item.yuzde}%`, backgroundColor: item.renk }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
